import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { ApContentModule } from '@ap/content';
import { ApGridModule } from '@ap/grid';
import { ApSkeletonComponent } from '@ap/skeleton';
import { ApContentPipe } from '@ap/content';
import { ApButtonComponent } from '@ap/button';

import { MKAppsPageComponent } from './apps-page.component';

/**
 * @ngdoc module
 * @name MKHomePageModule
 */
@NgModule({
    imports: [CommonModule, BrowserModule, ApContentModule, ApGridModule, ApSkeletonComponent, ApContentModule, ApButtonComponent],
    declarations: [MKAppsPageComponent],
    exports: [MKAppsPageComponent],
    providers: [ApContentPipe]
})
export class MKAppsPageModule {}
